import React, { useState } from 'react';
import DailyTaskPage from './Task/DailyTaskPage';
import TaskApprovalPage from './Task/TaskApprovalPage';

const TaskPage = () => {
  const [activeTab, setActiveTab] = useState('daily');

  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="bg-sky-400 text-white text-center p-4 font-bold text-lg">
        Activity 
      </div>

      {/* Tabs */}
      <div className="flex">
        <button
          className={`flex-1 py-2 font-semibold ${activeTab === 'daily' ? 'bg-orange-400 text-white' : 'bg-orange-300'}`}
          onClick={() => setActiveTab('daily')}
        >
          Daily Task
        </button>
        <button
          className={`flex-1 py-2 font-semibold ${activeTab === 'approval' ? 'bg-orange-400 text-white' : 'bg-orange-300'}`}
          onClick={() => setActiveTab('approval')}
        >
          Task Approval
        </button>
      </div>

      {/* Content */}
      <div className="flex-1 bg-slate-700 text-white flex justify-center items-center">
        {activeTab === 'daily' ? <DailyTaskPage /> : <TaskApprovalPage />}
      </div>
    </div>
  );
};

export default TaskPage;
